import { Card, Grid } from "@mui/material";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import FieldsGetter from "components/fields/fields";
import Layout from "components/LayoutContainers/mainLayout";
import LinearProgressComponent from "components/linearProgress/linearProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ReportYearFilter from "components/reportYearFilter/reportYearFilter";
import DataTable from "components/Tables/DataTable";
import { nearMissData } from "layouts/tables/data/tableDataGenerator";
import { useEffect, useState } from "react";
import { getLastNYears } from "utils/common/getLast10Years";
import { getCurrentMonthYear } from "utils/common/getYearNMonth";

export default function BestNM() {
    const [selected, setSelected] = useState(getCurrentMonthYear())
    const [formData, setFormData] = useState({ periodo: new Date().getFullYear() })
    const [yearNearMiss, setYearNearMiss] = useState({
        data: [],
        total: 0,
        perPage: 10,
        page: 1,
    })

    const [monthNearMiss, setMonthNearMiss] = useState({
        data: [],
        total: 0,
        perPage: 10,
        page: 1,
    })
    const { fetchData, loading } = GeneralFetch()
    const { rows, columns } = nearMissData({ data: monthNearMiss?.data, object: 'nearmisses', best: true })
    const { rows: yearsRows } = nearMissData({ data: yearNearMiss?.data, object: 'nearmisses', best: true })

    const onChange = (id, value) => setFormData({ [id]: value })

    useEffect(() => {
        const fetchDataAsync = async () => fetchData({}, `listBests?year=${formData.periodo}&month=${selected}&yearPage=${yearNearMiss?.page}&monthPage=${monthNearMiss?.page}`, 'get', '')
        void fetchDataAsync().then((data) => {
            setYearNearMiss(prev => ({ ...prev, data: data?.bestAno?.data, total: data?.bestAno?.total }))
            setMonthNearMiss(prev => ({ ...prev, data: data?.bestMes?.data, total: data?.bestMes?.total }))
        })
    }, [selected, formData.periodo, yearNearMiss?.page, monthNearMiss?.page])

    return (
        <Layout>
            <Grid container marginTop={"0px"} spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={0}
                            px={0}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            {(loading) && <LinearProgressComponent />}

                            <div style={{ display: "flex", justifyContent: "space-between", height: "25px", margin: "10px 10px 20px 10px" }} >
                                <MDTypography variant="h6" color="white" style={{ marginTop: "5px" }}>
                                    Relatório de best near misses
                                </MDTypography>
                                <div style={{ display: "flex", width: "150px" }} >
                                    <MDTypography variant="h6" color="white" style={{ marginTop: "5px", marginRight: "10px" }}>
                                        Ano:
                                    </MDTypography>
                                    <FieldsGetter props={{
                                        fieldId: 'periodo',
                                        required: false,
                                        label: 'Ano:',
                                        flex: true,
                                        type: 'select',
                                        options: getLastNYears(10),
                                        value: formData?.periodo,
                                        onChange
                                    }} />
                                </div>
                            </div>
                        </MDBox>
                        <MDBox pt={3}>
                            <ReportYearFilter setPeriod={setSelected} selectedYear={formData.periodo} fullYear={true} showSelect={false} selected={selected} setSelected={setSelected} monthly={true} />
                        </MDBox>
                    </Card>

                    <Card style={{ marginTop: "30px" }} >
                        <div style={{ display: "flex", justifyContent: "space-between" }} >
                            <MDTypography variant="h6" color="info" style={{ marginTop: "5px", margin: "10px 0 20px 20px" }}>
                                Best near misses de {selected}
                            </MDTypography>
                            <MDTypography variant="h6" color="info" style={{ marginTop: "5px", margin: "10px 20px 0 0" }}>
                                Total: {monthNearMiss?.total}
                            </MDTypography>
                        </div>
                        <DataTable
                            table={{ columns: columns?.filter(x => x.table == true), rows }}
                            showTotalEntries={false}
                            noEndBorder
                            setPaging={setMonthNearMiss}
                            paging={monthNearMiss}
                            hidePerPage={true}
                        />
                    </Card>

                    <Card style={{ margin: "30px 0 20px 0" }} >
                        <div style={{ display: "flex", justifyContent: "space-between" }} >
                            <MDTypography variant="h6" color="info" style={{ marginTop: "5px", margin: "10px 0 20px 20px" }}>
                                Best near misses de {formData.periodo}
                            </MDTypography>
                            <MDTypography variant="h6" color="info" style={{ marginTop: "5px", margin: "10px 20px 0 0" }}>
                                Total: {yearNearMiss.total}
                            </MDTypography>
                        </div>
                        <DataTable
                            table={{ columns: columns?.filter(x => x.table == true), rows: yearsRows }}
                            showTotalEntries={false}
                            noEndBorder
                            setPaging={setYearNearMiss}
                            paging={yearNearMiss}
                            hidePerPage={true}
                        />
                    </Card>
                </Grid>
            </Grid>
        </Layout>
    )
}